(function () {
  const STORAGE_KEY = "wholesale_saved_cart_v1";
  const WHOLESALE_TAG_TEXT = "WHOLESALE"; // your rule: wholesale products contain WHOLESALE in title

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart fetch failed");
    return await res.json();
  }

  function cartHasWholesale(cart) {
    return (cart.items || []).some((item) => {
      const title = item?.product_title ? String(item.product_title) : "";
      return title.toUpperCase().includes(WHOLESALE_TAG_TEXT);
    });
  }

  function saveCartToLocal(cart) {
    // Save variant id + qty (+ properties if you want)
    const payload = {
      saved_at: Date.now(),
      items: (cart.items || []).map((i) => ({
        id: i.id, // variant id
        quantity: i.quantity,
        properties: i.properties || null
      }))
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  }

  async function clearCart() {
    await fetch("/cart/clear.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" }
    });
  }

  document.addEventListener(
    "click",
    async function (e) {
      const el = e.target?.closest ? e.target.closest("a,button") : null;
      if (!el) return;

      const href = el.tagName === "A" ? (el.getAttribute("href") || "") : "";
      const text = (el.textContent || "").toLowerCase();

      const looksLikeLogout =
        el.classList.contains("account__logout") ||
        (href && href.toLowerCase().includes("logout")) ||
        text.includes("log out") ||
        text.includes("logout");

      if (!looksLikeLogout) return;

      e.preventDefault();

      try {
        const cart = await getCart();

        // Only save/clear if wholesale items exist (your confidentiality rule)
        if (cartHasWholesale(cart)) {
          saveCartToLocal(cart);
          await clearCart();
        }
      } catch (err) {
        // If anything fails, still proceed to logout (don't block user)
      }

      // Proceed to logout
      if (href) window.location.assign(href);
      else window.location.assign("/account/logout");
    },
    true
  );
})();